module.exports = __webpack_public_path__ + "static/marche-44728f76f29d3e39e26e0b459a5b8f5f.ttf";